var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.25C4.86614 4.25 4.75 4.13386 4.75 4V1C4.75 0.866142 4.86614 0.75 5 0.75C5.13386 0.75 5.25 0.866142 5.25 1V4C5.25 4.13386 5.13386 4.25 5 4.25Z",
    stroke: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.25C12.8661 4.25 12.75 4.13386 12.75 4V1C12.75 0.866142 12.8661 0.75 13 0.75C13.1339 0.75 13.25 0.866142 13.25 1V4C13.25 4.13386 13.1339 4.25 13 4.25Z",
    stroke: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18 7.5V16C18 19 16.5 21 13 21H5C1.5 21 0 19 0 16V7.5C0 4.5 1.5 2.5 5 2.5H13C16.5 2.5 18 4.5 18 7.5Z",
    fill: "#007AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.25H5C4.86614 10.25 4.75 10.1339 4.75 10C4.75 9.86614 4.86614 9.75 5 9.75H13C13.1339 9.75 13.25 9.86614 13.25 10C13.25 10.1339 13.1339 10.25 13 10.25Z",
    stroke: "#007AFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75H5C4.59 15.75 4.25 15.41 4.25 15C4.25 14.59 4.59 14.25 5 14.25H9C9.41 14.25 9.75 14.59 9.75 15C9.75 15.41 9.41 15.75 9 15.75Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteActive);
export default __webpack_public_path__ + "static/media/note-active.4809efd82a49e513505f6589ebffe1e1.svg";
export { ForwardRef as ReactComponent };